export default __webpack_public_path__ + "static/media/168.bb6bbe63.jpg";